import React, { useState } from 'react';
import styles from './drawerItem.module.scss';
import { AccordeonArrow } from '../../../../Assets/Icons';
import { DrawerItemTypes } from '../../../../Interfaces/componentTypes';

interface IProps {
  onClick?: () => void,
  icon: string,
  title: string
  titleStyle?: string,
  type?: DrawerItemTypes
}

const DrawerItem: React.FC<IProps> = (props) => {
  const { onClick, icon, title, titleStyle, type } = props;
  const [show, setShow] = useState<boolean>(false);

  return (
    <div className={styles.itemBox} onClick={() => {
      onClick!();
      setShow(prev => !prev)
    }}>
      <div className={styles.item}>
        <img src={icon} alt='icon' className={styles.itemIcon} />
        <p className={`${styles.itemTitle} ${titleStyle}`}>
          {title}
        </p>
      </div>
      {
        type === DrawerItemTypes.ACCORDEON
        &&
        <img
         src={AccordeonArrow}
          alt='arrow.svg' 
          className={`${styles.arrowIcon} ${show ? styles.arrowIconRotated : ''}`}
          />
      }
    </div>
  )
}

export default DrawerItem
